import { SpaceVertical } from '@looker/components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import { type DragEvent, type FC, useRef, useState } from 'react';
import { BrowseLabel, StyledDropzone } from '../style';
import { ALLOWED_EXTENSIONS } from '../utils';

interface FileDropzoneProps {
  onFileSelect: (file: File) => void;
  title: string;
}

export const FileDropzone: FC<FileDropzoneProps> = ({ onFileSelect, title }) => {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (!isDragging) setIsDragging(true);
  };

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      onFileSelect(files[0]);
    }
  };

  const handleBrowseClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <SpaceVertical gap="u2">
      <DsTypography variant="label">Upload File With {title} (One Item Per Line)</DsTypography>

      <StyledDropzone
        isDragging={isDragging}
        onDragOver={handleDragOver}
        onDragEnter={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={handleBrowseClick}
      >
        <DsTypography variant="label">{isDragging ? 'Drop file here' : 'Drag and Drop File'}</DsTypography>

        <DsTypography>
          or
          <BrowseLabel forwardedAs="span" display="inline" weight="bold" textDecoration="underline" color="brand">
            Browse Computer
          </BrowseLabel>
        </DsTypography>

        <input
          type="file"
          ref={fileInputRef}
          hidden
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) onFileSelect(file);
            e.target.value = '';
          }}
          accept={ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(',')}
        />
      </StyledDropzone>
    </SpaceVertical>
  );
};
